// This will host the main pages for each of the Resource Pages (Mechanical, Electrical, etc.)

import { BaseResourceTemplate } from "./Components/BaseResourceTemplate"
import { FaCog, FaBolt, FaTint, FaFire, FaDraftingCompass, FaQuestionCircle } from "react-icons/fa"

export function MechanicalPage() {
    return <BaseResourceTemplate type="mechanical" title="Mechanical" description="Mechanical Resources" icon={FaCog} />
}

export function ElectricalPage() {
    return <BaseResourceTemplate type="electrical" title="Electrical" description="Electrical Resources" icon={FaBolt} />
}

export function PlumbingPage() {
    return <BaseResourceTemplate type="plumbing" title="Plumbing" description="Plumbing Resources" icon={FaTint} />
}

export function FireProtectionPage() {
    return <BaseResourceTemplate type="fire protection" title="Fire Protection" description="Fire Protection Resources" icon={FaFire} />
}

export function CADPage() {
    return <BaseResourceTemplate type="cad" title="CAD" description="CAD Resources" icon={FaDraftingCompass} />
}

export function HelpPage() {
    return <BaseResourceTemplate type="help" title="Help" description="Find help on navigating the website and other features." icon={FaQuestionCircle} />
}